import { CardContainer } from '@app/components/Container/CardContainer';
import { Modal } from '@mui/material';
import React, { FC } from 'react';

type Props = {
    title: string;
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
};

export const ModalContainer: FC<Props> = (props) => {
    return (
        <Modal open={props.open} onClose={() => props.onClose()}>
            <CardContainer styles={style} title={props.title} onClose={() => props.onClose()} isModal={true}>
                {props.children}
            </CardContainer>
        </Modal>
    );
};

const style: React.CSSProperties = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
};
